import { Box, Stack, Typography, alpha } from '@mui/material';
import { ethers } from 'ethers';
import React from 'react';
import { useTheme } from '@mui/material/styles';

const AssetRow = ({
  amount,
  iconSrc,
  title,
  convertionValue,
}: {
  amount: bigint;
  iconSrc: string;
  title: string;
  convertionValue?: number;
}) => {
  const theme = useTheme();

  return (
    <Stack
      direction={'row'}
      sx={{ justifyContent: 'space-between', alignItems: 'center' }}
    >
      <Stack direction={'row'} gap={1} sx={{ alignItems: 'center' }}>
        <Box
          component={'img'}
          src={iconSrc}
          sx={{ width: '24px', height: '24px' }}
        />
        <Typography sx={{ fontSize: '12px', lineHeight: 1 }}>
          {title}
        </Typography>
      </Stack>
      <Stack textAlign={'end'}>
        <Typography
          sx={{ fontWeight: 'bold', fontSize: '14px', lineHeight: 1 }}
        >
          {Number(ethers.formatEther(BigInt(amount))).toLocaleString('en-US', {
            maximumFractionDigits: 4,
            minimumFractionDigits: 4,
          })}
        </Typography>
        {!convertionValue ? (
          <Typography
            sx={{
              fontSize: '10px',
              lineHeight: 1,
              color: theme.palette.darkGrey.light,
              marginTop: '4px',
            }}
          >
            Not Applicable
          </Typography>
        ) : (
          <Typography
            sx={{
              fontSize: '10px',
              lineHeight: 1,
              color: theme.palette.darkGrey.light,
              marginTop: '4px',
            }}
          >
            $
            {parseFloat(
              Number(ethers.formatEther(BigInt(amount))).toLocaleString(
                'en-US',
                {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                }
              )
            ) * convertionValue}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default AssetRow;
